import React, { useState } from "react";
import ConfirmationDialog from "../../components/Dialogs/ConfirmationDialog";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import actionCreator from "../../redux/action/actionCreator";
import {
  RESET_PUBLISH_STORE,
  PUBLISH_OR_UNPUBLISH_CONTENT,
} from "../../redux/general/types";
import Toast from "../../components/MessageToast";

const ConfirmModelContainer = (props) => {
  const { isOpen, isFor, handleCloseModel, itemId, isUnpublish } = props;
  const dispatch = useDispatch();

  const publishStore = useSelector((state) => state.publishGlobalStore);

  const [state, setState] = useState({
    openToast: false,
  });
  const handlePublishConfirm = async () => {
    dispatch(
      actionCreator({
        method: "",
        path: "",
        actionType: RESET_PUBLISH_STORE,
      })
    );
    await toast.promise(
      dispatch(
        actionCreator({
          method: "PATCH",
          path: `/api/${isFor.toLowerCase()}/${itemId}`,
          actionType: PUBLISH_OR_UNPUBLISH_CONTENT,
          data: { status: isUnpublish ? "unpublished" : "published" },
        })
      ),
      {
        pending: `${isUnpublish ? "Unpublish" : "Publish"} ${isFor.slice(
          0,
          -1
        )}`,
      }
    );
    handleCloseModel(false);
    setState({ ...state, openToast: true });
  };

  const navigate = useNavigate();

  if (!!publishStore.message && state.openToast) {
    Toast({
      message: publishStore.message,
      type: publishStore.message.includes("successful") ? "success" : "error",
      onClose: () =>
        publishStore.message.includes("successful") ? navigate(-1) : null,
    });

    setState({ ...state, openToast: false });
  }
  
  return (
    <ConfirmationDialog
      open={isOpen}
      message={`Do you want to ${
        isUnpublish ? "Unpublish" : "Publish"
      } this ${isFor.slice(
        0,
        -1
      )}, Kindly note that this action might be irreversible`}
      onCancel={() => handleCloseModel(false)}
      onConfirm={handlePublishConfirm}
    />
  );
};

export default ConfirmModelContainer;
